<template>
  <div class="page-content row" id="YourFunds">
    <div class="col s12 m11 main-page-content">

      <div class="col l3 sidebar hide-on-med-and-down">
        <div class="card">
          <user-info />
        </div>

        <div class="card">
          <provision-table/>
        </div>

        <div class="card">
          <contact/>
        </div>

        <div class="card">
          <find-us/>
        </div>
      </div>

      <div class="col s12 l9 ">
        <modal-payout v-if="showModal" :saldo="getPaymentSaldo" :showModal="showModal" @close="toggleModal"/>

        <div class="card standard-card stats-card">
          <div class="headline">
            <div class="title">
              <h1>Dokładne statystyki</h1>
            </div>

            <div class="payout-accessories">
              <button class="btn btn-payout" v-bind:class="{ disable: !getPayoutPossibility }"
                      v-on:click="isPaymentReady()">
                <i class="mfind-icon-money"></i>
                 Wypłata wynagrodzenia
              </button>
            </div>
          </div>

          <stats-grid />
        </div>

        <div class="card standard-card stats-card col s12 hide-on-large-only">
          <provision-table/>
        </div>

        <promotor-tranches class="card standard-card stats-card col s12"/>

        <div class="card standard-card stats-card col s12">
          <stats-chart :chartType="'AreaChart'" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('statistics')
import FindUs from '@/components/findUs'
import Contact from '@/components/contact'
import UserInfo from '@/components/userInfo'
import StatsGrid from '@/components/statsGrid'
import ProvisionTable from '@/components/provisionTable'
import StatsChart from '@/components/statsChart'
import PromotorTranches from '@/components/promotorTranches'
import ModalPayout from '@/components/modalPayout'
export default {
  components: { UserInfo, FindUs, StatsGrid, ProvisionTable, StatsChart, PromotorTranches, ModalPayout, Contact },
  name: 'YourFounds',
  computed: {
    // mix the getters into the computed object
    ...mapGetters([
      'getPayoutPossibility',
      'getPaymentSaldo'
    ])
  },
  data () {
    return {
      showModal: false
    }
  },
  methods: {
    toggleModal: function () {
      this.showModal = !this.showModal
    },
    isPaymentReady: function () {
      if (this.getPayoutPossibility) {
        this.toggleModal()
      }
    }
  }
}
</script>
<style lang="scss" src="./yourFunds.scss"></style>



// WEBPACK FOOTER //
// yourFunds.vue?481f2b88